import { observable } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/observable.js?vue3';

export const staticBreadcrumbs = observable('static_breadcrumbs', {
  items: [],
  hasInjectedBreadcrumbs: false,
});
